import React from "react";

const Course = ({ student, index,state,mt,pt,et }) => {
  

  return (
    <div className="w-full border grid grid-cols-[1fr_2fr_4fr_1fr_1fr_1fr_1fr_1fr_1.5fr] gap-1 p-1 text-sm">
               <div className="w-full text-center">
                {index+1}
               </div>
               <div className="w-full text-center">
               <p className="text-gray-700 ">{student.rollno}</p>
               </div>
               <div className="w-full text-left">
               <p className={`${student.name === "NOT FOUND" ? "text-red-600" : "text-gray-700"}`}>
               {student.name}
               </p>
               </div>
               <div  className="w-full  text-center">
               <p
                    className={`w-full border-b border-gray-400 hover:border-blue-500 text-center font-semibold 
                    ${student.midterm < 0 || student.midterm > mt ? 'text-red-500' : 'text-blue-800'}`}
                    >
                    {student.midterm || 0}
                    </p>
               </div>
               <div className="w-full">
               <p
                    className={`w-full border-b border-gray-400 hover:border-blue-500 text-center font-semibold 
                    ${student.practical < 0 || student.practical > pt ? 'text-red-500' : 'text-blue-800'}`}
                    >
                    {student.practical || 0}
                    </p>
               </div>
               <div className="w-full">
               <p
                    className={`w-full border-b border-gray-400 hover:border-blue-500 text-center font-semibold 
                    ${student.endterm < 0 || student.endterm > et ? 'text-red-500' : 'text-blue-800'}`}
                    >
                    {student.endterm || 0}
                    </p>
               </div>
               <div  className="text-center w-full">
                <p className="w-full">{student.grand_total||0}</p>
               </div>
               
               <div  className="text-center w-full">
               <p className="w-full">{(student.percent ?? 0).toFixed(2)}</p>
               </div>
               <div className="text-center w-full">
                    <select
                    className=" p-1  bg-transparent w-full border-b border-gray-400 focus:border-blue-500 outline-none text-center font-semibold text-blue-800"
                    value={student.grade} disabled={state !== 'gradecomputation'}
                    >
                    <option value="">SELECT</option>
                    <option value="O">O</option>
                    <option value="A+">A+</option>
                    <option value="A">A</option>
                    <option value="B+">B+</option>
                    <option value="B">B</option>
                    <option value="C+">C+</option>
                    <option value="C">C</option>
                    <option value="P">P</option>
                    <option value="F">F</option>
                    <option value="ABS">ABS</option>
                    </select>
               </div>
        </div>
  );
};

export default Course;
